import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SideBar from '../portal/controls/sidebar/sideBar';
import PortalTabs from '../../components/portal/portalTabs';
import SessionMonitor from './sessionMonitor';

@inject('translationsStore', 'oidcStore', 'authStore') @observer
export default class PrivateRouteWrapper extends Component {
    
    componentDidMount() {

        if(!this.props.authStore.sessionTimeout){
            this.props.authStore.getSessionTimeout();
        }
    }
    
    userLoggedIn = () => {
      
        if(!this.props.oidcStore.currentUser || this.props.oidcStore.currentUser.expired) {
          return false;
        }
  
        return true;
    }
    
    render(){

        if(!this.userLoggedIn()) { 
            
            this.props.oidcStore.reloadPageWithNewToken();
            return null;
        }

        if(!this.props.authStore.sessionTimeout){
            return null
        }
        
        return (
            <div className='portal-main-wrapper'>
                <SessionMonitor sessionTimeout={this.getSessionTimeout()} />
                <SideBar />
                <div className='main-header' data-cy='access-control-header'>
                    <div className="header-main-title" data-cy='access-control-header-main-title'>
                        {this.props.translationsStore.translate('ACCESS_CONTROL')}
                    </div>
                    <div className='main-viewers-navbar'>
                        <PortalTabs />
                    </div>
                </div>
                <div className='main-body'>
                    {this.props.children}
                </div>
            </div>
        )
    }

    getSessionTimeout = () => {
        
        const sessionTimeoutInSeconds = this.props.authStore.sessionTimeout.sessionTimeout * 60;
        const sessionTimeoutInMilliSeconds = 1000 * sessionTimeoutInSeconds;
        
        return sessionTimeoutInMilliSeconds;
    }
}


// WEBPACK FOOTER //
// ./src/components/router/privateRouteWrapper.jsx